import axios, { AxiosResponse } from 'axios'
import { date } from 'yup'

type CheckCodeResponse = {
  errorMessage: string
  data?: any
}

export const checkCode = async (code: string): Promise<CheckCodeResponse> => {
  const endPoint = String(process.env.REACT_APP_REGIS_SERVICE_ENDPOINT)
  const eventId = String(process.env.REACT_APP_EVENT_ID)

  if (!!!process.env.REACT_APP_REGIS_SERVICE_ENDPOINT || !!!eventId)
    return {
      errorMessage: 'Something wrong. Please try another available Entrant Code.',
    }

  const response = await axios.post(endPoint, {
    DEVICE_ID: '87d3cd94-87d5-46a4-ae9e-cb33fb12f888',
    EVENT_ID: eventId,
    CODE: code.replace(/^\s+|\s+$/gm, ''),
    ACTION: 'CHECK',
    EVENT_ACCOUNT_ID: code.replace(/^\s+|\s+$/gm, ''),
    VALIDATE: 'CHECK',
    data_profile: {},
    conmail: true,
  })

  const result: CheckCodeResponse = {
    errorMessage: '',
    data: response.data,
  }

  // unknown error
  if (response.data.statusCode !== 0)
    result.errorMessage = 'Invalid redemption code. Please try again with a different code.'

  // event not found
  if (response.data.statusCode === 91)
    result.errorMessage = 'This code has been redeemed. Please try with a different code.'

  // event not found
  if (response.data.statusCode === 92) result.errorMessage = 'Event notfound'

  // code not found
  if (response.data.statusCode === 93)
    result.errorMessage =
      'The 9-digit Entrant Code you entered was not found. Please re-confirm the Entrant Code.'

  // code un available
  if (response.data.statusCode === 94)
    result.errorMessage =
      'The Entrant Code can not register due to transfer in process or transferred. Please try another available Entrant Code.'

  // code already registered ! BY API
  if (response.data.statusCode === 110)
    result.errorMessage = 'This code has been redeemed. Please try with a different code.'

  return result
}

export type RegisBody = {
  FIRST_NAME?: string
  LAST_NAME?: string
  AGE?: number
  EMAIL?: string
  PHONE_NUMBER?: string
  DATA_003?: string // national id
}

export const regis = async (code: string, body: RegisBody) => {
  const endPoint = String(process.env.REACT_APP_REGIS_SERVICE_ENDPOINT)
  const eventId = String(process.env.REACT_APP_EVENT_ID)

  return await axios.post(endPoint, {
    DEVICE_ID: '87d3cd94-87d5-46a4-ae9e-cb33fb12f888',
    EVENT_ID: eventId,
    CODE: code.replace(/^\s+|\s+$/gm, ''),
    ACTION: 'CHECK',
    EVENT_ACCOUNT_ID: code.replace(/^\s+|\s+$/gm, ''),
    VALIDATE: 'UPDATE_VALIDATED',
    data_profile: body,
    conmail: true,
    ...body,
  })
}
